module.exports = __webpack_public_path__ + "ViasatMotorNO-77bf72513287f11cfc85b14f10ae56ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/ViasatMotorNO.jpg
// module id = 1150
// module chunks = 0 1